export function colorToRGBA(color) {
  let rgba;

  if (color.charAt(0) === '#') {
    color = color.slice(1);
  }

  if (color.length === 6) {
    rgba = _.map(color.match(/../g), pair => parseInt(pair, 16));
    rgba.push(1);
    return rgba;
  }

  if (color.length === 3) {
    rgba = _.map(color.match(/./g), pair => parseInt(pair + pair, 16));
    rgba.push(1);
    return rgba;
  }

  rgba = _(color)
    .replace(/^rgba?\(/, '')
    .replace(/\)$/, '')
    .split(',')
    .map(value => Number(value));

  if (rgba.length === 3) {
    rgba.push(1);
  }

  return rgba;
}

export function makeRGBA(color, opacity) {
  const colorRGBA = colorToRGBA(color);
  colorRGBA[3] = (_.isFunction(opacity)
    ? opacity(colorRGBA[3])
    : opacity
  ).toFixed(2);
  return `rgba(${colorRGBA.join(',')})`;
}
